const BASE_EVENT_STRING = 'application/vnd.amazonaws.connect.event';

export default {
  TYPING: `${BASE_EVENT_STRING}.typing`,
  ENDED: `${BASE_EVENT_STRING}.chat.ended`,
  TRANSFER_SUCCEEDED: `${BASE_EVENT_STRING}.transfer.succeeded`,
  TRANSFER_FAILED: `${BASE_EVENT_STRING}.transfer.failed`,
  MESSAGE_METADATA: `${BASE_EVENT_STRING}.message.metadata`,
  PARTICIPANT_IDLE: `${BASE_EVENT_STRING}.participant.idle`,
  PARTICIPANT_RETURNED: `${BASE_EVENT_STRING}.participant.returned`,
  PARTICIPANT_JOINED: `${BASE_EVENT_STRING}.participant.joined`,
  PARTICIPANT_LEFT: `${BASE_EVENT_STRING}.participant.left`,
} as Record<string, connect.ChatEventContentType>;
